<template>
  <router-link v-if="settlementLink" :to="settlementLink" target="_blank" class="settlement-year-month">
    {{ displayedText }}
  </router-link>
  <span v-else class="settlement-year-month">
    {{ displayedText }}
  </span>
</template>

<script>
import {DateUtils} from '@/utils/date-utils';

export default {
  name: 'SettlementYearMonth',
  mixins: [
    DateUtils
  ],
  props: ['value'],
  computed: {
    displayedText() {
      if(this.value == null) {
        return '-';
      }
      return this.formatYearMonth(this.value.year, this.value.month, '-')
    },
    settlementLink() {
      if(this.value == null || this.value.id == null) {
        return null;
      }
      return {
        name: 'SettlementDetails',
        params: {
          settlementId: this.value.id
        }
      }
    }
  }
}
</script>

<style scoped>
.booking-id {
  display: inline-block;
}
</style>